import { useTranslation } from '@/i18n'

function USFlag() {
  return (
    <svg width="20" height="14" viewBox="0 0 60 42" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="60" height="42" fill="#B22234" />
      <rect y="3.23" width="60" height="3.23" fill="white" />
      <rect y="9.69" width="60" height="3.23" fill="white" />
      <rect y="16.15" width="60" height="3.23" fill="white" />
      <rect y="22.62" width="60" height="3.23" fill="white" />
      <rect y="29.08" width="60" height="3.23" fill="white" />
      <rect y="35.54" width="60" height="3.23" fill="white" />
      <rect width="24" height="22.62" fill="#3C3B6E" />
      <g fill="white">
        <circle cx="4" cy="2.5" r="1" /><circle cx="8" cy="2.5" r="1" /><circle cx="12" cy="2.5" r="1" /><circle cx="16" cy="2.5" r="1" /><circle cx="20" cy="2.5" r="1" />
        <circle cx="6" cy="5" r="1" /><circle cx="10" cy="5" r="1" /><circle cx="14" cy="5" r="1" /><circle cx="18" cy="5" r="1" />
        <circle cx="4" cy="7.5" r="1" /><circle cx="8" cy="7.5" r="1" /><circle cx="12" cy="7.5" r="1" /><circle cx="16" cy="7.5" r="1" /><circle cx="20" cy="7.5" r="1" />
        <circle cx="6" cy="10" r="1" /><circle cx="10" cy="10" r="1" /><circle cx="14" cy="10" r="1" /><circle cx="18" cy="10" r="1" />
        <circle cx="4" cy="12.5" r="1" /><circle cx="8" cy="12.5" r="1" /><circle cx="12" cy="12.5" r="1" /><circle cx="16" cy="12.5" r="1" /><circle cx="20" cy="12.5" r="1" />
        <circle cx="6" cy="15" r="1" /><circle cx="10" cy="15" r="1" /><circle cx="14" cy="15" r="1" /><circle cx="18" cy="15" r="1" />
        <circle cx="4" cy="17.5" r="1" /><circle cx="8" cy="17.5" r="1" /><circle cx="12" cy="17.5" r="1" /><circle cx="16" cy="17.5" r="1" /><circle cx="20" cy="17.5" r="1" />
        <circle cx="6" cy="20" r="1" /><circle cx="10" cy="20" r="1" /><circle cx="14" cy="20" r="1" /><circle cx="18" cy="20" r="1" />
      </g>
    </svg>
  )
}

function RomaniaFlag() {
  return (
    <svg width="20" height="14" viewBox="0 0 60 42" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="20" height="42" fill="#002B7F" />
      <rect x="20" width="20" height="42" fill="#FCD116" />
      <rect x="40" width="20" height="42" fill="#CE1126" />
    </svg>
  )
}

export function LanguageSwitcher() {
  const { language, setLanguage } = useTranslation()

  return (
    <button
      onClick={() => setLanguage(language === 'en' ? 'ro' : 'en')}
      className="relative w-11 h-11 flex items-center justify-center rounded-full hover:bg-primary/10 gentle-animation cursor-pointer"
      aria-label={language === 'en' ? 'Schimbă în Română' : 'Switch to English'}
    >
      {language === 'en' ? <USFlag /> : <RomaniaFlag />}
    </button>
  )
}
